/**
 * @generated SignedSource<<7f5162c7b6cb5fec3408cbaacafb5756>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassExitSlipsFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  includeCanceled?: boolean | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type ExitSlipAllClassExitSlipQuery$variables = {
  filter?: ClassExitSlipsFilterInput | null | undefined;
};
export type ExitSlipAllClassExitSlipQuery$data = {
  readonly classExitSlips: ReadonlyArray<{
    readonly canceledOn: any | null | undefined;
    readonly class: {
      readonly id: string;
    } | null | undefined;
    readonly curriculumLesson: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly number: string | null | undefined;
    } | null | undefined;
    readonly dueOn: any;
    readonly id: string;
    readonly learnosityExitSlipSessions: ReadonlyArray<{
      readonly sessionCompletedOn: any;
    } | null | undefined> | null | undefined;
  }>;
};
export type ExitSlipAllClassExitSlipQuery = {
  response: ExitSlipAllClassExitSlipQuery$data;
  variables: ExitSlipAllClassExitSlipQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueOn",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canceledOn",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ClassNode",
  "kind": "LinkedField",
  "name": "class",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "CurriculumLessonNode",
  "kind": "LinkedField",
  "name": "curriculumLesson",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionCompletedOn",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipAllClassExitSlipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnosityExitSlipSessionNode",
            "kind": "LinkedField",
            "name": "learnosityExitSlipSessions",
            "plural": true,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipAllClassExitSlipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnosityExitSlipSessionNode",
            "kind": "LinkedField",
            "name": "learnosityExitSlipSessions",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "648423514e096001b30cab0d2e17abbf",
    "id": null,
    "metadata": {},
    "name": "ExitSlipAllClassExitSlipQuery",
    "operationKind": "query",
    "text": "query ExitSlipAllClassExitSlipQuery(\n  $filter: ClassExitSlipsFilterInput\n) {\n  classExitSlips(filter: $filter) {\n    id\n    dueOn\n    canceledOn\n    class {\n      id\n    }\n    curriculumLesson {\n      id\n      number\n      name\n    }\n    learnosityExitSlipSessions {\n      sessionCompletedOn\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b49ec71fb3b77166adf2d929ac818a1c";

export default node;
